<template>
  <div class="ui form" ref="form">
    <h4 class="ui dividing header">{{ $t("general info") }}</h4>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("ldap url") }}</label>
        <input type="text" name="ldap_url" v-model="ldap_url" />
      </div>
      <div class="field">
        <label for>{{ $t("base distinguished name") }}</label>
        <input type="text" name="base_dn" v-model="base_dn" />
      </div>
    </div>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("username") }}</label>
        <input type="text" name="username" v-model="username" />
      </div>
      <div class="field">
        <label for>{{ $t("password") }}</label>
        <input type="password" name="password" v-model="password" />
      </div>
    </div>
    <div class="ui icon labeled blue button" @click="test">
      <i class="plug icon"></i> {{ $t("test connection") }}
    </div>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import { local_api, success_toast } from "@/utils";

export default {
  name: "EnterpriseModalActiveDirectory",
  components: {},
  props: {
    setup_in: Object,
  },
  data() {
    return {
      ldap_url: "",
      base_dn: "",
      username: "",
      password: "",
      error_message: "",
    };
  },
  mounted() {
    let vm = this;

    if (vm.setup_in) {
      vm.ldap_url = vm.setup_in.ldap_url;
      vm.base_dn = vm.setup_in.base_dn;
      vm.username = vm.setup_in.username;
      vm.password = vm.setup_in.password;
    }
  },
  methods: {
    emit() {
      this.$emit("update", {
        ldap_url: this.ldap_url,
        base_dn: this.base_dn,
        // password: this.password,
        // username: this.username,
      });
    },
    test() {
      let vm = this;
      local_api(vm, "post", "/settings/enterprise/do-test-active-directory", {
        s: {
          ldap_url: vm.ldap_url,
          base_dn: vm.base_dn,
          username: vm.username,
          password: vm.password,
        },
      })
        .then((response) => {
          success_toast(response);
        })
        .catch((err) => {
          window.jQuery(vm.$refs.form).form("add errors", [err]);
        })
        .finally(() => {
          vm.processing = false;
        });
    },
  },
  watch: {
    ldap_url() {
      this.emit();
    },
    base_dn() {
      this.emit();
    },
    username() {
      this.emit();
    },
    password() {
      this.emit();
    },
  },
};
</script>
